import { DatePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { SubjectIcaroVM } from 'civil-status/view-models/form-declaration-icaro';
import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';

interface FormProps {
  disabled?: boolean;
  values?: SubjectIcaroVM;
  errors?: FormikErrors<SubjectIcaroVM>;
  touched?: FormikTouched<SubjectIcaroVM>;
  onChange: (key: keyof SubjectIcaroVM, value: SubjectIcaroVM[keyof SubjectIcaroVM]) => void;
  isDeclarant?: boolean;
}

const FormComponent = ({
  disabled,
  values,
  errors,
  touched,
  onChange,
  isDeclarant,
}: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Matricola"
          aria-label="Matricola"
          id="freshman"
          name="freshman"
          fullWidth
          disabled={disabled}
          helperText={errors?.freshman}
          error={touched?.freshman && Boolean(errors?.freshman)}
          type="text"
          variant="outlined"
          value={values?.freshman || ''}
          onChange={(event) => {
            onChange('freshman', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Num. famiglia"
          aria-label="Num. famiglia"
          id="numberFamily"
          name="numberFamily"
          fullWidth
          disabled={disabled}
          helperText={errors?.numberFamily}
          error={touched?.numberFamily && Boolean(errors?.numberFamily)}
          type="text"
          variant="outlined"
          value={values?.numberFamily || ''}
          onChange={(event) => {
            onChange('numberFamily', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Cognome"
          aria-label="Cognome"
          id="surname"
          name="surname"
          fullWidth
          disabled={disabled}
          helperText={errors?.surname}
          error={touched?.surname && Boolean(errors?.surname)}
          type="text"
          variant="outlined"
          value={values?.surname || ''}
          onChange={(event) => {
            onChange('surname', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          label="Nome"
          aria-label="Nome"
          id="name"
          name="name"
          fullWidth
          disabled={disabled}
          helperText={errors?.name}
          error={touched?.name && Boolean(errors?.name)}
          type="text"
          variant="outlined"
          value={values?.name || ''}
          onChange={(event) => {
            onChange('name', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data nascita"
          aria-label="Data nascita"
          value={values?.dateBorn || null}
          onChange={(date) => {
            onChange('dateBorn', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateBorn"
              fullWidth
              helperText={errors?.dateBorn}
              error={touched?.dateBorn && Boolean(errors?.dateBorn)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Comune nascita"
          aria-label="Comune nascita"
          id="municipalityBorn"
          name="municipalityBorn"
          fullWidth
          disabled={disabled}
          helperText={errors?.municipalityBorn}
          error={touched?.municipalityBorn && Boolean(errors?.municipalityBorn)}
          type="text"
          variant="outlined"
          value={values?.municipalityBorn || ''}
          onChange={(event) => {
            onChange('municipalityBorn', event.target.value);
          }}
        />
      </Grid>
      {/* <Grid item xs={12} md={2}>
        <PmiTextField
          label="Provincia nascita"
          aria-label="Provincia nascita"
          id="provinceBorn"
          name="provinceBorn"
          fullWidth
          disabled={disabled}
          helperText={errors?.provinceBorn}
          error={touched?.provinceBorn && Boolean(errors?.provinceBorn)}
          type="text"
          variant="outlined"
          value={values?.provinceBorn || ''}
          onChange={(event) => {
            onChange('provinceBorn', event.target.value);
          }}
        />
      </Grid> */}
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Comune residenza"
          aria-label="Comune residenza"
          id="municipalityResidence"
          name="municipalityResidence"
          fullWidth
          disabled={disabled}
          helperText={errors?.municipalityResidence}
          error={touched?.municipalityResidence && Boolean(errors?.municipalityResidence)}
          type="text"
          variant="outlined"
          value={values?.municipalityResidence || ''}
          onChange={(event) => {
            onChange('municipalityResidence', event.target.value);
          }}
        />
      </Grid>
      {/* <Grid item xs={12} md={2}>
        <PmiTextField
          label="Provincia residenza"
          aria-label="Provincia residenza"
          id="provinceResidence"
          name="provinceResidence"
          fullWidth
          disabled={disabled}
          helperText={errors?.provinceResidence}
          error={touched?.provinceResidence && Boolean(errors?.provinceResidence)}
          type="text"
          variant="outlined"
          value={values?.provinceResidence || ''}
          onChange={(event) => {
            onChange('provinceResidence', event.target.value);
          }}
        />
      </Grid> */}
      {isDeclarant ? (
        <Grid item xs={12}>
          <PmiTextField
            label="Veste in cui è comparso"
            aria-label="Veste in cui è comparso"
            id="guise"
            name="guise"
            fullWidth
            disabled={disabled}
            helperText={errors?.guise}
            error={touched?.guise && Boolean(errors?.guise)}
            type="text"
            variant="outlined"
            value={values?.guise || ''}
            onChange={(event) => {
              onChange('guise', event.target.value);
            }}
          />
        </Grid>
      ) : undefined}
    </Grid>
  );
};

FormComponent.displayName = 'Subject Icaro - Form Component';

const Form = memo(FormComponent);

export default Form;
